import { useTranslation } from 'react-i18next'
import { Controller, useFormContext } from 'react-hook-form'

import { USERNAME_MAX_LENGTH } from 'cat-shared/utils'
import { AppFormInput } from 'client/ui-building-blocks'

type Props = {
  isLoading: boolean
}

const UsernameInput = ({ isLoading }: Props) => {
  const { t } = useTranslation()

  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Controller
      control={control}
      name="username"
      rules={{
        required: t('common.validation.required'),
      }}
      render={({ field: { value, onChange } }) => {
        return (
          <AppFormInput
            value={value}
            onChange={onChange}
            label={t('common.username.label')}
            maxLength={USERNAME_MAX_LENGTH}
            disabled={isLoading}
            error={String(errors?.username?.message || '')}
          />
        )
      }}
    />
  )
}

export default UsernameInput
